import Icon from '@/components/ui/AppIcon';

interface ProcessStepProps {
  step: {
    number: string;
    title: string;
    description: string;
    icon: string;
    details: string[];
  };
  index: number;
}

const ProcessStep = ({ step, index }: ProcessStepProps) => {
  const isEven = index % 2 === 0;

  return (
    <div className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 items-center`}>
      <div className="flex-1 w-full">
        <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-200 hover:border-[#42AF47]/30">
          <div className="flex items-start gap-4 mb-6">
            <div className="flex-shrink-0 w-16 h-16 bg-[#42AF47]/10 rounded-xl flex items-center justify-center">
              <Icon name={step.icon as any} size={32} className="text-[#42AF47]" />
            </div>
            <div className="flex-1">
              <div className="inline-block px-3 py-1 bg-[#42AF47]/10 rounded-full mb-3">
                <span className="text-sm font-semibold text-[#42AF47]">{step.number}</span>
              </div>
              <h3 className="text-2xl font-heading font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          </div>

          <div className="space-y-3 mt-6 pt-6 border-t border-gray-200">
            {step.details.map((detail, idx) => (
              <div key={idx} className="flex items-start gap-3">
                <Icon name="CheckCircleIcon" size={20} className="text-[#42AF47] flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-700">{detail}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex-shrink-0 hidden lg:flex items-center justify-center">
        <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#42AF47] to-[#2e8b3f] flex items-center justify-center shadow-lg">
          <span className="text-3xl font-heading font-bold text-white">{index + 1}</span>
        </div>
      </div>
    </div>
  );
};

export default ProcessStep;